var _style, _circle, _circle2, _circle3, _circle4, _circle5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28.35 28.35",
    style: {
      enableBackground: "new 0 0 28.35 28.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t@keyframes colorChange {\n\t\t0% { fill: #D7000F; }\n\t\t20% { fill: #231815; }\n\t\t40% { fill: #FFFFFF; }\n\t\t60% { fill: #ADDEF8; }\n\t\t80% { fill: #FFE037; }\n\t\t100% { fill: #D7000F; }\n\t}\n\t.st0{ fill: #D7000F; animation: colorChange 1.5s steps(1) infinite; }\n\t.st1{ fill: #231815; animation: colorChange 1.5s steps(1) .3s infinite; }\n\t.st2{ fill: #FFFFFF; animation: colorChange 1.5s steps(1) .6s infinite; }\n\t.st3{ fill: #ADDEF8; animation: colorChange 1.5s steps(1) .9s infinite; }\n\t.st4{ fill: #FFE037; animation: colorChange 1.5s steps(1) 1.2s infinite; }\n\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 14.03,
    cy: 5.45,
    r: 3.76
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 5.73,
    cy: 10.87,
    r: 3.31
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 6.13,
    cy: 18.97,
    r: 2.46
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 11.78,
    cy: 23.03,
    r: 1.96
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 18.98,
    cy: 22.03,
    r: 1.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.6e3526690ac8e90e5e7c44aa5c65b9cb.svg";
export { ForwardRef as ReactComponent };